var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReshotIconWebHostingAndFtpYal35Qc47U(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#96c0ff;}.cls-2{fill:#b8d4ff;}.cls-3{fill:#fff;}.cls-4{fill:#ebf4ff;}.cls-5{fill:#c3d4ef;}.cls-6{fill:#d3bcfb;}.cls-7{fill:#f8fafd;}.cls-8{fill:#e5eefd;}.cls-9{fill:#f1f2f2;}.cls-10{fill:#a9ebc8;}.cls-11{fill:#283d54;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "11.Web Hosting and FTP") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_11.Web_Hosting_and_FTP",
    "data-name": "11.Web Hosting and FTP"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_Group_",
    "data-name": "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M95,11V68H1V11A4,4,0,0,1,5,7H91A4,4,0,0,1,95,11Z"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 7,
    y: 7,
    width: 3,
    height: 61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 86,
    y: 7,
    width: 3,
    height: 61
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "58 83 67 95 29 95 38 83 58 83"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M95,68V79a4,4,0,0,1-4,4H5a4,4,0,0,1-4-4V68Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "58 83 38 83 35 87 61 87 58 83"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M86,4v7H10V4a3,3,0,0,1,3-3H83A3,3,0,0,1,86,4Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 10,
    y: 11,
    width: 76,
    height: 57
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "47 60 50 64 20 64 23 60 47 60"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "47 44 50 48 20 48 23 44 47 44"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "47 28 50 32 20 32 23 28 47 28"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M54,51v6a3,3,0,0,1-3,3H19a3,3,0,0,1-3-3V51a3,3,0,0,1,3-3H51A3,3,0,0,1,54,51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M54,35v6a3,3,0,0,1-3,3H19a3,3,0,0,1-3-3V35a3,3,0,0,1,3-3H51A3,3,0,0,1,54,35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M54,19v6a3,3,0,0,1-3,3H19a3,3,0,0,1-3-3V19a3,3,0,0,1,3-3H51A3,3,0,0,1,54,19Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_Group_2",
    "data-name": "<Group>"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 62,
    y: 18,
    width: 18,
    height: 44,
    rx: 2,
    ry: 2
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M80,20a2.006,2.006,0,0,0-2-2H64a2.006,2.006,0,0,0-2,2v4H80Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M91,6H87V4a4,4,0,0,0-4-4H13A4,4,0,0,0,9,4V6H5a5.006,5.006,0,0,0-5,5V79a5.006,5.006,0,0,0,5,5,1,1,0,0,0,0-2,3,3,0,0,1-3-3V69H94V79a3,3,0,0,1-3,3H10a1,1,0,0,0,0,2H36L28.5,94H25a1,1,0,0,0,0,2H71a1,1,0,0,0,0-2H67.5L60,84H91a5.006,5.006,0,0,0,5-5V11A5.006,5.006,0,0,0,91,6ZM65,94H31l7.5-10h19ZM11,4a2,2,0,0,1,2-2H83a2,2,0,0,1,2,2v6H11ZM2,11A3,3,0,0,1,5,8H9V67H2ZM87,67V32a1,1,0,0,0-2,0V67H11V12H85V27a1,1,0,0,0,2,0V8h4a3,3,0,0,1,3,3V67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M50,76a1,1,0,0,0,0-2H46a1,1,0,0,0,0,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M15,7h3a1,1,0,0,0,0-2H15a1,1,0,0,0,0,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M79,7h2a1,1,0,0,0,0-2H79a1,1,0,0,0,0,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M72,7h2a1,1,0,0,0,0-2H72a1,1,0,0,0,0,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M51,15H25a1,1,0,0,0,0,2H51a2,2,0,0,1,2,2v6a2,2,0,0,1-2,2H19a2,2,0,0,1-2-2V19a2,2,0,0,1,2-2,1,1,0,0,0,0-2,4,4,0,0,0-4,4v6a4,4,0,0,0,4,4h2l-1.5,2H19a4,4,0,0,0-4,4v6a4,4,0,0,0,4,4h2l-1.5,2H19a4,4,0,0,0-4,4v6a4,4,0,0,0,4,4h2l-1.5,2H16a1,1,0,0,0,0,2H54a1,1,0,0,0,0-2H50.5L49,61h2a4,4,0,0,0,4-4V51a4,4,0,0,0-4-4h-.5L49,45h2a4,4,0,0,0,4-4V35a4,4,0,0,0-4-4h-.5L49,29h2a4,4,0,0,0,4-4V19A4,4,0,0,0,51,15ZM48,63H22l1.5-2h23Zm5-12v6a2,2,0,0,1-2,2H19a2,2,0,0,1-2-2V51a2,2,0,0,1,2-2H51A2,2,0,0,1,53,51Zm-5-4H22l1.5-2h23Zm5-12v6a2,2,0,0,1-2,2H19a2,2,0,0,1-2-2V35a2,2,0,0,1,2-2H51A2,2,0,0,1,53,35Zm-5-4H22l1.5-2h23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M20,23a1,1,0,0,0,2,0V21a1,1,0,0,0-2,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M27,23V21a1,1,0,0,0-2,0v2a1,1,0,0,0,2,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M32,23V21a1,1,0,0,0-2,0v2a1,1,0,0,0,2,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M49,23a1,1,0,0,0,0-2H37a1,1,0,0,0,0,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M21,36a1,1,0,0,0-1,1v2a1,1,0,0,0,2,0V37A1,1,0,0,0,21,36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M26,36a1,1,0,0,0-1,1v2a1,1,0,0,0,2,0V37A1,1,0,0,0,26,36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M31,36a1,1,0,0,0-1,1v2a1,1,0,0,0,2,0V37A1,1,0,0,0,31,36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M49,37H37a1,1,0,0,0,0,2H49a1,1,0,0,0,0-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M21,52a1,1,0,0,0-1,1v2a1,1,0,0,0,2,0V53A1,1,0,0,0,21,52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M26,52a1,1,0,0,0-1,1v2a1,1,0,0,0,2,0V53A1,1,0,0,0,26,52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M31,52a1,1,0,0,0-1,1v2a1,1,0,0,0,2,0V53A1,1,0,0,0,31,52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M49,53H37a1,1,0,0,0,0,2H49a1,1,0,0,0,0-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M78,17H64a3,3,0,0,0-3,3V60a3,3,0,0,0,3,3H78a3,3,0,0,0,3-3V20A3,3,0,0,0,78,17Zm1,43a1,1,0,0,1-1,1H64a1,1,0,0,1-1-1V20a1,1,0,0,1,1-1H78a1,1,0,0,1,1,1Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReshotIconWebHostingAndFtpYal35Qc47U);
export default __webpack_public_path__ + "static/media/reshot-icon-web-hosting-and-ftp-YAL35QC47U.d0c40680c2cf0905b00a1d64ef28b869.svg";
export { ForwardRef as ReactComponent };